import { TAU } from './math.ts';

export interface Weapon {
  /** Wielding it renames the player: "Sniper Ana". */
  playerTitle: string;
  /** Bullets spawned by a single shot. */
  burst: number;
  /** Milliseconds before the weapon can fire again. */
  burstDelay: number;
  /** Widest angle a bullet can stray from the aim, in radians. */
  deviation: number;
  /**
   * Rolled in order on every shot; the first roll that passes divides the
   * deviation by its position + 2. Only one of them can trigger.
   */
  reliability: number[];
  /** Shots before a reload is due. */
  clipSize: number;
  reloadTime: number;
  /** Pixels per second. */
  bulletSpeed: number;
  /** Pixels a bullet covers before it dies. */
  range: number;
}

export type WeaponName = keyof typeof WEAPONS;

const degrees = (value: number) => (value / 360) * TAU;

export const WEAPONS = {
  revolver: {
    playerTitle: 'Gunslinger',
    burst: 1,
    burstDelay: 200,
    deviation: degrees(10),
    reliability: [0.5, 0.3, 0.1],
    clipSize: 7,
    reloadTime: 2500,
    bulletSpeed: 300,
    range: 400,
  },
  shotgun: {
    playerTitle: 'Breacher',
    burst: 7,
    burstDelay: 400,
    deviation: degrees(20),
    reliability: [0.6],
    clipSize: 6,
    reloadTime: 4000,
    bulletSpeed: 250,
    range: 200,
  },
  sniper: {
    playerTitle: 'Sniper',
    burst: 1,
    burstDelay: 0,
    deviation: degrees(7),
    reliability: [0.7, 0.5, 0.3, 0.2, 0.1],
    clipSize: 1,
    reloadTime: 750,
    bulletSpeed: 500,
    range: 5000,
  },
  rifle: {
    playerTitle: 'Soldier',
    burst: 1,
    burstDelay: 50,
    deviation: degrees(12),
    reliability: [0.9, 0.7],
    clipSize: 30,
    reloadTime: 2000,
    bulletSpeed: 400,
    range: 600,
  },
} as const satisfies Record<string, Weapon>;

export const WEAPON_NAMES = Object.keys(WEAPONS) as WeaponName[];
